import {observable, action, computed} from 'mobx';
import patterns from '@techsee/techsee-common/lib/constants/utils.patterns';
import {ITranslate} from '../../services/LocalizationService';

export class ScanResultModalController {
    @observable type: string = '';
    @observable result: any = null;
    @observable dir: 'rtl' | 'ltr' = 'ltr';
    @observable searchTags: boolean = false;

    @observable copyResults: Record<string, string> = {};

    @observable isVisible = false;

    private resolver: ((data: any) => void) | null = null;

    constructor(public translate: ITranslate) {}

    @action
    show(type: string, result: any, dir: 'rtl' | 'ltr', searchTags: boolean) {
        this.type = type;
        this.result = result;
        this.dir = dir;
        this.searchTags = searchTags;

        this.isVisible = true;

        return new Promise((resolve) => {
            this.resolver = resolve;
        });
    }

    @action
    close(data?: any) {
        this.isVisible = false;
        if (this.resolver) {
            this.resolver(data);
            this.resolver = null;
        }
    }

    @computed
    get resultsFound(): boolean {
        if (!this.result) return false;

        // Check for structured results (arrays)
        const hasStructuredResults = Object.entries(this.result).some(
            ([key, items]: [string, any]) => key !== 'text' && Array.isArray(items) && items.length > 0
        );

        // Check for text results
        const hasTextResults = !!this.result.text;

        return hasStructuredResults || hasTextResults;
    }

    @computed
    get displayText(): boolean {
        return !!this.result?.text;
    }

    @computed
    get formattedText(): string {
        if (!this.result?.text) return '';

        const text = this.result.text;
        const raw = text.rawAligned || (text.lines && text.lines.join('\n')) || text.raw;

        return raw
            .split('\n')
            .map((substr: string) => substr.replace(patterns.url, '<a href="$&" target="_blank">$&</a>'))
            .join('\n');
    }

    @action
    markCopySuccess(id: string) {
        this.copyResults[id] = 'SCAN.RESULT.COPY_SUCCEED';

        setTimeout(
            action(() => {
                this.copyResults[id] = '';
            }),
            1000
        );
    }

    @action
    markCopyError(id: string) {
        this.copyResults[id] = 'SCAN.RESULT.COPY_FAILED';

        setTimeout(
            action(() => {
                this.copyResults[id] = '';
            }),
            1000
        );
    }

    @action
    triggerSearch(type: string, index?: number) {
        const searchTerm = index !== undefined ? this.result?.[type]?.[index]?.value : this.result?.text?.raw || '';

        this.close({
            search: true,
            searchTerm
        });
    }
}
